/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Discover_Title8Inputs */

const en_svc_mvp_sprint_discover_title8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoped discovery`)
};

const ar_svc_mvp_sprint_discover_title8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشاف محدد`)
};

const bn_svc_mvp_sprint_discover_title8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সীমাবদ্ধ আবিষ্কার`)
};

const de_svc_mvp_sprint_discover_title8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingegrenzte Discovery`)
};

const es_svc_mvp_sprint_discover_title8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubrimiento acotado`)
};

const fr_svc_mvp_sprint_discover_title8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découverte cadrée`)
};

const pt_svc_mvp_sprint_discover_title8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descoberta delimitada`)
};

const zh_svc_mvp_sprint_discover_title8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限定范围的需求梳理`)
};

const tr_svc_mvp_sprint_discover_title8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapsamlı keşif`)
};

const ru_svc_mvp_sprint_discover_title8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очерченный дискавери`)
};

const pl_svc_mvp_sprint_discover_title8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ograniczone discovery`)
};

/**
* | output |
* | --- |
* | "Scoped discovery" |
*
* @param {Svc_Mvp_Sprint_Discover_Title8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_discover_title8 = /** @type {((inputs?: Svc_Mvp_Sprint_Discover_Title8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Discover_Title8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_discover_title8(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_discover_title8(inputs)
	if (locale === "de") return de_svc_mvp_sprint_discover_title8(inputs)
	if (locale === "es") return es_svc_mvp_sprint_discover_title8(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_discover_title8(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_discover_title8(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_discover_title8(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_discover_title8(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_discover_title8(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_discover_title8(inputs)
	return en_svc_mvp_sprint_discover_title8(inputs)
});
export { svc_mvp_sprint_discover_title8 as "svc_mvp-sprint_DISCOVER_title" }